module.exports = __webpack_public_path__ + "static_pc/img/16.c07c0c32.png";